import * as React from 'react'
import { withStyles, WithStyles } from '@zn-material-ui'
import agreementsStyle from './AgreementsStyle'

interface IProps extends WithStyles<typeof agreementsStyle> {
  hideTitle?: boolean
}

const ServiceAgreement: React.SFC<IProps> = ({ classes, hideTitle }) => (
  <div className={classes.container}>
    {!hideTitle && <div className={classes.title}>e祺学用户许可及服务协议</div>}
    <div className={classes.con}>
      <p>亲爱的用户，欢迎您使用e祺学APP、来做课软件及相关服务！</p>
      <p>深圳城智通信息技术有限公司及其关联公司（下称“e祺学”或“本公司”）拥有并经营e祺学网站（www.zhi-niao.com）、e祺学客户端APP等。</p>
      <p>本协议是e祺学用户（以下简称“您”或“用户”）与本公司之间关于用户下载、安装、使用e祺学APP、来做课软件等平台相关软件或工具，并接受相应服务的法律协议。本协议由您和本公司签订。</p>
      <p>“e祺学APP”作为一款移动学习APP，“企业独立APP”为基于e祺学APP底层构架生成的具有企业独立logo的企业独立移动学习APP(涵盖以企业自身证书、账户或e祺学证书、账户上传发布至应用市场的独立App)，“来做课软件”为上述APP的辅助学习软件，其中e祺学APP、企业独立APP、来做课软件，以下简称为“e祺学相关APP”或“平台”。e祺学相关APP可为企业及个人用户提供包括学习、制作、交流和信息储存空间的服务，其中涵盖了e祺学绝大多数专业系列的知识内容，用户通过e祺学相关APP可以完成课件制作，可以下载学习，可以在线学习，也可以移动学习，课程内容精短，配合视频动画、游戏闯关、答题竞赛等方式多样教学，具体以平台实际提供为准。</p>
      <p>本协议所述“课件”即包括但不限于文字、图片、视频、flash、游戏作品等。成为e祺学相关APP及本协议的尊贵用户,您需先行注册，且勾选“同意”按钮，本协议自动生效，您即应遵守本协议所有条款。</p>

      <br/>
      <div>1. 声明及承诺</div>
      <p>1.1  本协议已对与您的权益有或可能具有重大关系的条款，及对本公司具有或可能具有免责或限制责任的条款用粗体字予以标注，请您注意。您确认，在您注册成为e祺学用户以接受本服务之前，您已充分阅读、理解并接受本协议的全部内容，一旦您使用本服务，即表示您同意遵循本协议之所有约定。</p>
      <p>1.2  您同意，本公司有权随时对本协议内容进行单方面的变更，并以在本网站公告的方式予以公布，无需另行单独通知您；若您在本协议内容公告变更后继续使用本服务的，表示您已充分阅读、理解并接受修改后的协议内容，也将遵循修改后的协议内容使用本服务；若您不同意修改后的协议内容，您应停止使用本服务。</p>
      <p>1.3  您保证，在您同意接受本协议并注册成为e祺学用户时，您已年满10周岁，并在法定监护人的陪同下阅读本协议，并特别注意未成年人使用条款，或者是在中华人民共和国境内（香港、澳门、台湾地区除外）合法开展经营活动或其他业务的法人或其他组织；本协议内容不受您所属国家或地区法律的排斥。不具备前述条件的，您应立即终止注册或停止使用本服务。</p>
      <p>1.4  未成年人使用条款：本公司非常重视对未成年人个人信息的保护。若您是18周岁以下的未成年人，在使用本服务前，应事先取得您家长或法定监护人的书面同意。您在使用e祺学服务时，应自行判断并自行决定是否与对方进行交易或转账给对方等，且您应自行承担与此相关的所有风险。用户的下载、安装、使用、帐号获取和登录等行为将视为已接受本协议所有条款及其约束。</p>

      <br/>
      <div>2. 权利与资质声明</div>
      <p>2.1  本公司对e祺学相关APP均享有包括商标权、专利权、著作权、商业秘密等在内的全部知识产权及所有权。任何人未经本公司书面许可，不得为任何商业或非商业目的，以任何形式对上述任一软件以及上述软件本身所包含的任一知识产权要素擅自使用（不包括用户通过本APP，利用上述软件自行上传的课件及资料），否则，本公司将保留追究上述侵权行为法律责任的权利。</p>
      <p>2.2  用户于任何时间，通过e祺学相关APP发表的任何内容（包括但不限于：文字、图片、视频、flash、游戏作品）均应被视为已授权本公司对上述任一作品在其著作权的最大地域范围内、最长保护期限内，免费、持续、不可撤销、可再许可地使用，包括但不限于：复制权、发行权、出租权、展览权、表演权、放映权、广播权、信息网络传播权、摄制权、改编权、翻译权、汇编权等以及《著作权法》规定的由著作权人享有的其他著作财产权利。并且，上述发表行为同样应被视为，用户已许可本公司就任何主体涉嫌侵犯上述任一作品的行为，有权以自己名义单独提起诉讼，并获得全部赔偿。</p>
      <p>2.3  用户承诺，对其通过e祺学相关APP上传或发布的所有内容（包括用户名、昵称、签名）均拥有合法、完整的包括著作权、商标权等在内的知识产权或已获得相关权利人的合法授权，未侵犯任何第三方的包括著作权、商标权、专利权、商业秘密等在内的知识产权及人身权等合法权益，否则，由此引发的任何诉讼、主张，用户均应独立承担所有法律责任，就任何第三人针对本公司的任何主张或诉讼，以及本公司因此遭受的任何损失，用户亦应承担包括赔偿在内的一切法律责任。</p>

      <br/>
      <div>3.   软件许可范围</div>
      <p>3.1  e祺学相关APP提供包括但不限于IOS、android等多个应用版本，用户须选所安装终端相匹配的软件版本。</p>
      <p>3.2  授予用户一项个人的、永久性、不可转让和非排他的使用许可，以使用e祺学相关APP。用户可以为非商业目的在单一台终端设备上安装并使用e祺学相关APP。</p>
      <p>3.3  本条及本协议其他条款未明示授权的其他一切权利仍归本公司所有。除非有书面明示，本公司不放弃相关权益。</p>
      <p>3.4  若用户对e祺学相关APP有任何意见或改进的建议，均可向本公司提出。</p>

      <br/>
      <div>4. 权利限制</div>
      <p>4.1  禁止反向工程、反向编译和反向汇编：用户不得对e祺学相关APP进行反向工程（Reverse Engineer）、反向编译（Decompile）或反向汇编（Disassemble），同时不得改动编译在程序文件内部的任何资源。除法律、法规明文规定允许上述活动外，用户必须遵守此协议限制。</p>
      <p>4.2  组件分割:e祺学相关APP是作为一个单一产品而被授予许可使用，用户不得将各个部分分开用于任何目的。</p>
      <p>4.3  个别授权:如需进行商业性的销售、复制、分发，包括但不限于软件销售、预装、捆绑等，必须获得本公司的书面授权和许可。</p>
      <p>4.4  保留权利：本协议未明示授权的其他一切权利仍归本公司所有，用户使用其他权利时必须获得本公司的书面同意。</p>

      <br/>
      <div>5. 软件的安装、升级及终止</div>
      <p>5.1  用户可以直接从本公司官网上获取并安装e祺学相关APP，也可以从本公司授权的第三方应用中下载。如果用户从非以上的第三方获取e祺学相关APP或与e祺学相关APP名称相同的安装程序，本公司无法保证该软件能够正常使用，并对因此给用户造成的损失不予负责。</p>
      <p>5.2  请下载并安装适合的终端软件版本，并请按照软件提示步骤正确安装。为提供更加优质、安全的服务，在e祺学相关APP安装时本公司可能推荐用户安装其他软件，用户可以选择安装或不安装。</p>
      <p>5.3  如用户不再需要使用e祺学相关APP，有权利自行卸载e祺学相关APP。</p>
      <p>5.4  为了保证e祺学相关APP及服务的安全性和功能的一致性，本公司有权不经特别通知，而对e祺学相关APP做不定期更新，或者对软件的部分功能效果进行改变或限制。为保证用户的使用体验，请及时下载最新版本并升级，本公司不保证旧版e祺学相关APP继续可用及对应的客户服务。</p>
      <p>5.5  本公司拥有不经事先通知而修改软件功能、中断或中止软件使用的权利。</p>

      <br/>
      <div>6. 用户使用须知</div>
      <p>6.1  e祺学账户：是本公司向您提供的唯一编号。您可自行设置密码，并用以查询或计量您的预付、应收或应付款。您需使用本人电子邮箱或手机号码，或者本公司允许的其它方式，例如通过扫描二维码或识别生物特征的方式，作为登录手段登录该e祺学账户。</p>
      <p>6.2  账户注册相关</p>
      <p>除本协议另有规定或相关产品另有规则外，您须在客户端注册并取得本公司提供给您的e祺学账户，或在您于其他网站完成e祺学登录名注册，并且按照本公司要求提供相关信息完成激活后方可使用本服务。您同意：</p>
      <p>6.2.1  按照e祺学要求准确提供并在取得该账户后及时更新您正确、最新及完整的身份信息及相关资料。若本公司有合理理由怀疑您提供的身份信息及相关资料错误、不实、失效或不完整的，本公司有权暂停或终止向您提供部分或全部e祺学服务。本公司对此不承担任何责任，您将承担因此产生的任何直接或间接支出。若因国家法律法规、部门规章或监管机构的要求，本公司需要您补充提供任何相关资料时，如您不能及时配合提供，本公司有权暂停或终止向您提供部分或全部e祺学服务。</p>
      <p>6.2.2  您确认，只有您本人可以使用您的e祺学账户。在您决定不再使用该账户时，您应按照本协议规定向本公司申请注销该账户。</p>
      <p>6.2.3  您同意，若您丧失全部或部分民事权利能力或民事行为能力，本公司有权根据有效法律文书（包括但不限于生效的法院判决、生效的遗嘱等）或本公司认可的其他资料处置您e祺学账户内款项。</p>
      <p>6.3  用户信息及账户安全</p>
      <p>6.3.1  本公司非常重视用户的隐私权，将会尽最大努力保护用户的个人信息。除法律法规规定的情形外，未经用户许可本公司不会向第三方公开、透露用户个人信息。</p>
      <p>6.3.2  本公司拥有完善的信息管理安全制度，为保障用户个人信息的安全，对重要用户信息采用了专业的加密存储与传输方式，以免用户信息遭受未经授权的访问、使用或披露。</p>
      <p>6.3.3  用户在使用e祺学相关APP的过程中，需要提供一些必要的个人信息，如手机号码、地理位置等，因产品服务与实际使用功能相关联，若用户提供的信息不完整、不真实，则可能在使用过程中受限或无法使用部分功能。</p>
      <p>6.3.4  用户使用e祺学相关APP，即视为理解并同意以下授权条款：</p>
      <p>6.3.5  用户授权本公司，除法律另有规定之外，将用户本人提供给本公司的信息、因享受本公司服务而产生的信息（包括本协议签署之前提供和产生的信息）以及本公司根据本条约定查询、收集的信息，用于本公司及因服务必要而委托的合作伙伴为用户本人提供服务、推荐产品、开展市场调查与信息数据分析。</p>
      <p>6.3.6  用户明确确认授权并许可本公司向用户留存的邮箱、手机、地址等发送商业信息。</p>
      <p>6.3.7  为确保用户信息的安全，本公司及其合作伙伴对上述信息负有保密义务，并采取各种措施保证信息安全。</p>
      <p>6.3.8  如用户不同意上述授权条款的部分或全部，可致电客服热线（95511）取消或变更授权。</p>
      <p>6.4  帐号使用须知</p>
      <p>6.4.1  e祺学相关APP帐号的所有权归本公司所有，用户完成申请注册手续后，仅获得e祺学相关APP帐号的使用权，且该使用权仅属于首次申请注册人，同时，首次申请注册人不得赠与、借用、租用、转让或售卖e祺学相关APP帐号或者以其他方式许可非首次申请注册人使用e祺学相关APP帐号。非首次申请注册人不得通过受赠、继承、承租、受让或者其他任何方式使用e祺学相关APP账号。</p>
      <p>6.4.2  用户有责任妥善保管注册帐户信息及帐户密码的安全，用户需要对本人注册帐户下的行为独立承担法律责任。用户在任何情况下均不得向他人透露帐户及密码信息，否则，由此造成的任何损失，用户均应自行承担法律责任在怀疑他人使用自己帐号时，用户应立即通知本公司进行处理。</p>
      <p>6.4.3  用户长期不登录其注册的e祺学相关APP帐号，本公司有权回收该帐号，并清理相关存储数据，以免造成资源浪费，由此带来的任何损失均由用户自行承担。</p>
      <p>6.4.4  用户需为本人注册帐号下的一切行为独立承担负责，包括个人所发表的任何内容以及由此产生的任何后果。用户应对e祺学相关APP账号及其服务中的内容自行加以判断，并承担因使用而引起的所有风险，包括因对内容的正确性、完整性或实用性的依赖而产生的风险。本公司无法且不会对因前述风险而导致的任何损失或损害承担责任。</p>
      <p>6.5  注销相关</p>
      <p>在需要终止使用本服务时，您可以申请注销您的e祺学账户，您同意：</p>
      <p>6.5.1  您所申请注销的e祺学账户应当是您依照本协议的约定注册并由本公司提供给您本人的账户。您应当依照本公司规定的程序进行e祺学账户注销。</p>
      <p>6.5.2  e祺学账户注销将导致本公司终止为您提供本服务，本协议约定的双方的权利义务终止（依本协议其他条款另行约定不得终止的或依其性质不能终止的除外），同时还可能对于该账户产生的结果：</p>
      <p>A、任何兑换代码（积分、购物券、礼品券或优惠券等）都将作废；</p>
      <p>B、任何银行卡将不能适用该账户内的支付或结算服务。</p>
      <p>6.5.3  您可以通过自助或者人工的方式申请注销e祺学账户，但如果您使用了本公司提供的安全产品，应当在该安全产品环境下申请注销。</p>
      <p>6.5.4  您申请注销的e祺学账户应当处于正常状态，即您的e祺学账户的账户信息和用户信息是最新、完整、正确的，且该账户可以使用所有e祺学服务功能。账户信息或用户信息失效、缺失、不正确的账户或被冻结的账户不能被申请注销。如您申请注销的账户有关联账户或子账户的，在该关联账户或子账户被注销前，该账户不得被注销。</p>
      <p>6.5.5  您申请注销的e祺学账户应当不存在任何由于该账户被注销而导致的未了结的合同关系与其他基于该账户的存在而产生或维持的权利义务，及本公司认为注销该账户会由此产生未了结的权利义务而产生纠纷的情况。</p>
      <p>6.5.6  您申请注销的e祺学账户一旦注销成功，将不再予以恢复。</p>
      <p>6.5.7  您理解并同意，如（a）您连续36个月未使用您的e祺学登录名或本公司认可的其他方式登录过本公司网站及其他任一本公司网站；或（b）您在任一本公司网站有欺诈、发布或销售伪劣商品、侵犯他人合法权益或其他严重违反任一本公司网站规则的行为的，本公司有权注销您名下的全部或部分e祺学登录名，您将不能再登录任一本公司网站，所有本公司网站的服务将同时终止。本公司有权将您违反前述约定的情形同步给其他本公司网站。</p>

      <br/>
      <div>7. 免责与责任限制</div>
      <p>7.1  用户对其通过e祺学相关APP上传或发布的法人作品及特殊职务作品，如未按照其本公司相关管理规定设置保密属性，从而导致自身商业秘密泄露的，均应独立承担相关法律责任，e祺学相关APP对此无需承担任何责任。</p>
      <p>7.2  用户在使用e祺学相关APP及服务时，须自行承担如下来自本公司不可掌控的风险内容，包括但不限于：</p>
      <p>7.2.1  由于不可抗拒因素可能引起的个人信息丢失、泄漏等风险；</p>
      <p>7.2.2  用户必须选择与所安装手机相匹配的软件版本，否则，由于软件与手机型号不相匹配所导致的任何问题或损害，均由用户自行承担；</p>
      <p>7.2.3  用户发布的内容被他人转发、分享，因此等传播可能带来的风险和责任；</p>
      <p>7.2.4  由于网络信号不稳定、带宽资源不足等原因，所引起的软件登录失败、资料同步不完整、页面打开速度慢等风险；</p>
      <p>7.2.5  如有需要，用户在使用e祺学相关APP访问第三方网站时，因第三方网站及相关内容所可能导致的风险，由用户自行承担；</p>
      <p>7.3  用户确认，其知悉e祺学相关APP所有功能及本公司为实现e祺学相关APP各功能所进行的必要操作，其根据自身需求自愿选择使用e祺学相关APP及相关服务，因使用e祺学相关APP及相关服务所存在的风险和一切后果将完全由其自己承担，本公司不承担任何责任。</p>
      <p>7.4  用户从非官方渠道下载e祺学相关APP，并因此受到广告信息、手机病毒、恶意收费服务的影响及损失，均与e祺学相关APP无关。</p>
      <p>7.5  e祺学相关APP经过详细的测试，但不能保证与所有的软硬件系统完全兼容，不能保证e祺学相关APP完全没有错误。如果出现不兼容及软件错误的情况，用户可在将情况报告本公司，获得技术支持。如果无法解决兼容性问题，用户可以删除e祺学相关APP。</p>
      <p>7.6  在适用法律允许的最大范围内，对因使用或不能使用e祺学相关APP所产生的损害及风险，包括但不限于直接或间接的个人损害、商业赢利的丧失、贸易中断、商业信息的丢失或任何其它经济损失，本公司不承担任何责任。</p>
      <p>7.7  对于因运营商系统或基础网络故障、计算机故障或病毒、信息损坏或丢失、计算机系统问题或其它任何不可抗力原因而产生损失，本公司不承担任何责任。</p>
      <p>7.8  本公司对不可抗力导致的损失不承担责任。本服务条款所指不可抗力包括：天灾、法律法规或政府指令的变更等。</p>

      <br/>
      <div>8. 行为规范</div>
      <p>8.1  用户的行为不得违反《计算机信息网络国际联网安全保护管理办法》、《互联网信息服务管理办法》、《互联网电子公告服务管理规定》、《互联网用户账号名称管理规定》《全国人大常委会关于维护互联网安全的决定》、《互联网新闻信息服务管理规定》等相关法律规定，不得利用e祺学相关APP及服务制作、复制、发布、传播如下侵犯其他用户或第三方合法权益、干扰e祺学相关APP正常运营的内容，不得利用e祺学相关APP及服务从事任何违法犯罪活动。包括但不限于：</p>
      <p><em>1） 发布、传送、传播、储存违反国家法律、危害国家安全统一、泄露国家秘密、破坏民族团结、破坏国家宗教政策、扰乱社会秩序、损害国家荣誉和利益、以非法民间组织名义的活动；</em></p>
      <p><em>2） 发布、传送、传播、储存违反社会稳定、公序良俗、社会公德以及侮辱、诽谤、淫秽或含有任何性或性暗示的、赌博、凶杀、恐怖或者教唆犯罪的、暴力的内容；</em></p>
      <p><em>3） 发布、传送、传播、储存侵害他人名誉权、隐私权、肖像权、知识产权、商业秘密等合法权利的内容；</em></p>
      <p><em>4） 侵犯他人隐私、个人信息或资料；</em></p>
      <p><em>5） 发表、传送、传播骚扰、广告信息及垃圾信息；</em></p>
      <p><em>6） 提交、发布虚假信息，或冒充、利用他人名义；</em></p>
      <p><em>7） 虚构事实、隐瞒真相以误导、欺骗他人；</em></p>
      <p><em>8） 使用不雅或不恰当ID和昵称；涉及反动、色情的头像、签名档和发布不良内容；</em></p>
      <p><em>9） 发表含有猥亵、色情、人身攻击和反政府言论等非法或侵权言论的；</em></p>
      <p><em>10） 从事非法商业活动；</em></p>
      <p><em>11） 模仿管理人员ID或者他人ID，用以假冒管理人员或破坏管理人员形象；</em></p>
      <p><em>12） 使用发贴机等非法软件进行违规发贴的行为；</em></p>
      <p><em>13） 发表含有本协议禁止发布、传播内容的文章；</em></p>
      <p><em>14） 发表不符合版面主题，或者无内容的灌水内容；</em></p>
      <p><em>15） 同一主题内容多次出现的；</em></p>
      <p><em>16） 违反本协议规定，发布违规广告的；</em></p>
      <p><em>17） 发布内容或个人签名会包含有严重影响用户浏览的内容或格式的；</em></p>
      <p><em>18） 其他本公司认为不恰当的情况；</em></p>
      <p><em>19） 其他违反法律法规、政策及公序良俗、社会公德或干扰e祺学相关APP正常运营和侵犯其他用户或第三方合法权益内容的信息；</em></p>
      <p>8.2  用户在遵守法律及本协议的前提下使用e祺学相关APP，在使用过程中不得侵犯本公司就e祺学相关APP享有的任何权利、权益，不得有下列任一行为，包括但不限于：</p>
      <p><em>1） 删除e祺学相关APP及其副本上关于著作权、商标权等知识产权的信息；</em></p>
      <p><em>2） 不得制作、发布、使用、传播用于窃取e祺学相关APP帐号及他人个人信息、财产的恶意程序；</em></p>
      <p><em>3） 对e祺学相关APP进行反向工程、反向汇编、反向编译，或者以其他方式尝试发现e祺学相关APP的源代码；</em></p>
      <p><em>4） 对本公司拥有知识产权的内容进行使用、出租、出借、复制、修改、链接、转载、汇编、发表、出版、建立镜像站点等；</em></p>
      <p><em>5） 对e祺学相关APP或者e祺学相关APP运行过程中释放到任何终端内存中的数据、软件运行过程中客户端与服务器端的交互数据，以及e祺学相关APP运行所必需的系统数据，进行复制、修改、增加、删除、挂接运行或创作任何衍生作品，形式包括但不限于使用插件、外挂或非本公司经授权的第三方工具/服务接入e祺学相关APP和相关系统；</em></p>
      <p><em>6） 通过修改或伪造软件运行中的指令、数据，增加、删减、变动软件的功能或运行效果，或者将用于上述用途的软件、方法进行运营或向公众传播，无论这些行为是否为商业目的；</em></p>
      <p><em>7） 通过非本公司开发、授权的第三方软件、插件、外挂、系统，登录或使用本公司软件及服务，或制作、发布、传播上述工具；</em></p>
      <p><em>8） 自行或者授权他人、第三方软件对e祺学相关APP及其组件、模块、数据进行干扰；</em></p>
      <p><em>9） 任何用户发现e祺学相关APP内的内容涉嫌侮辱或者诽谤他人、侵害他人合法权益的或违反e祺学相关APP协议的，有权按投诉规则进行投诉。</em></p>

      <br/>
      <p>9. 用户个人信息保护</p>
      <p>1）保护用户个人信息是我们的一项基本原则，我们将会采取合理的措施保护用户的个人信息。除法律法规规定的情形外，未经用户许可我们不会向第三方公开披露用户个人信息。我们对相关信息采用专业加密存储与传输方式，保障用户个人信息的安全。</p>
      <p>2）您在注册帐号或使用本服务的过程中，需要提供一些必要的信息，若您提供的信息不完整，则无法使用本服务或在使用过程中受到限制。</p>
      <p>3）对于我们会如何收集、使用、存储和保护您的个人信息及您享有何种权利，您可以阅读《隐私政策》予以进一步了解。</p>

      <br/>
      <div>10. 法律责任及违约处理</div>
      <p>10.1  如果用户违反上述行为规范或本协议的任何其他约定，或者收到其他用户的举报或投诉，本公司有权不经通知随时对相关内容进行删除，并视行为情节对违规帐号处以包括但不限于警告、限制或禁止使用部分或全部功能、封禁帐号并清空所有发言，直至注销账号的处罚，情节严重的，还将承担相应法律责任。</p>
      <p>10.2  因违反上述行为规范或本协议的任何其他约定，导致或产生任何第三方主张的任何索赔、要求，用户均应独立承担责任；任何第三人针对本公司的任何主张或诉讼，以及本公司因此遭受的任何损失，用户亦应承担包括赔偿在内的一切法律责任。</p>
      <p>10.3  本公司有权依合理判断对其认为确已违反有关法律法规或本协议规定的用户进行处罚，对违法违规的任何用户采取包括但不限于中断使用许可、停止提供服务、限制使用、追究法律责任等措施，以及依据法律法规保存有关信息并向有关部门报告等，因此产生的一切法律责任，用户均应独自承担。</p>
      <p>10.4  如因e祺学相关APP所使用的第三方软件或技术引发任何纠纷，应由该第三方负责解决并独立承担所有法律责任，本公司不承担任何责任。本公司不对第三方软件或技术提供客服支持，若您需要获取支持，请自行与第三方联系。</p>

      <br/>
      <div>11. 其他注意事项</div>
      <p>11.1  e祺学相关APP在非wifi使用场景中，会产生数据流量费用，用户需自行向运营商了解相关资费，并自行承担相关费用。</p>
      <p>11.2  用户在使用e祺学相关APP某一特定服务时（如视频服务），该服务可能会另有单独的协议、相关业务规则等（以下统称为“单独协议”），用户在使用该项服务前请仔细阅读并同意相关的单独协议。</p>
      <p>11.3  本公司将会尽力保障用户在e祺学相关APP及服务中的数据存储安全，但是， 本公司并不能完全保证所有用户数据完整，对于可能出现的存储失败、或服务终止、数据被删除等情况，本公司没有义务向用户提供或返还任何数据，也无需对用户因上述情形而遭受的任何损失承担包括赔偿在内的任何法律责任。</p>
      <p>11.4  本公司有权不定期更新本协议条款，一旦本协议的内容发生变动，本公司将会通过适当方式提示用户修改内容。</p>
      <p>11.5  用户可以在e祺学相关APP的最新版本中查阅更新后的协议条款。本公司提示协议条款更新后，如用户不同意本公司对本协议相关条款所做更新，有权停止使用e祺学相关APP及相应服务，如用户继续使用e祺学相关APP，即视为已接受更新后的协议条款。</p>
      <p>11.6  本协议的成立、生效、履行、解释及纠纷解决，均适用中华人民共和国大陆地区法律（不包括冲突法）。所有与本合同有关的争议应通过甲乙双方友好协商解决。如合同双方经协商仍未能解决争议，可将争议提交至深圳仲裁委员会进行仲裁。仲裁裁决为终局裁决，对双方均有约束力。由该仲裁产生的一切相关费用均由败诉方承担。</p>
      <p>11.7  除争议事项外，各方应继续行使各自在本合同项下的其他权利，履行各自在本合同项下的其他义务。</p>
      <p>11.8  如本协议中的任何条款因任何原因被判定为完全或部分无效或不具有执行力，本协议的其余条款仍应有效并且有执行力。</p>
    </div>
    <div className={classes.footer}>深圳城智通信息技术有限公司</div>
  </div>
)

export default withStyles(agreementsStyle)(ServiceAgreement)
